
import {Component, Prop, Vue} from 'vue-property-decorator';
import {queryDeclarationInfo, updateDeclarationInfo} from "@/api/booking-order";
import {queryMarkLetter} from "@/api/purchase-order";
import UpdateMark, {Mark} from "@/views/customs-management/edit/mark.vue";
import {CURRENCY_UNIT, INTERNATIONAL_TRADE_TERMS, LADING_TYPE, PAYMENT_TYPE} from "@/constant";
import {Message} from "element-ui";
import {ICustomerModel} from "@/api/types";
import {defaultCustomerData} from "@/api/customer";
import ShippingOrderInfo from "@/views/components/bookingorder/ShippingOrderInfo.vue";
import Template from "@/views/system-management/template/index.vue";

@Component({
  name: "DeclarationInfoConfirm",
  components: {Template, ShippingOrderInfo, UpdateMark},
  methods: {LADING_TYPE, PAYMENT_TYPE, INTERNATIONAL_TRADE_TERMS, CURRENCY_UNIT},
})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: false }) private edit: boolean;
  @Prop({ required: true, default: {} }) private bookingOrder: any;

  private declarationInfo: DeclarationInfo = new DeclarationInfo(
      defaultCustomerData,
      new DeclarationCharge(),
      "",
      "",
      ""
  );
  private markInput: string[] = [];
  private markLetters: Mark[] = [];

  private async open() {
    const {
      customer,
      declarationCharge,
      invoiceMoney,
      shippingMark,
      currencyUnit,
    }: any = await queryDeclarationInfo(this.bookingOrder.id);
    this.declarationInfo = new DeclarationInfo(
        customer,
        declarationCharge || new DeclarationCharge(),
        invoiceMoney,
        shippingMark,
        currencyUnit
    );
    this.markInput = shippingMark.split('；');
    const data: any = await queryMarkLetter([], this.bookingOrder.customerId)
    this.markLetters = data.map((item) => new Mark(item,false));
    this.getInsuranceAmount();
  }

  private close() {
    this.$emit("update:show", false);
  }

  private getInsuranceAmount() {
    if (this.declarationInfo.customer.internationalTradeTerms === "2") {
      let amount = Number(this.declarationInfo.invoiceMoney);
      amount = amount * 1.1 * 0.001;
      this.declarationInfo.declarationCharge.insuranceAmount = amount.toFixed(4);
    }
  }

  // 客人定价等级
  private renderCusAbbr(prop, row) {
    if (row.pcNames && row.pcNames.length > 0){
      return `[${row.pcNames}]${prop}`
    }
    return prop
  }

  private clearMarkLetters():boolean {
    this.markInput = this.declarationInfo.shippingMark.split('；');
    return true;
  }

  private showMarkEdit = false;
  private showMarkEditDialog() {
    this.showMarkEdit = true;
  }

  private handleEditMarkSuccess(marks: Mark[]) {
    this.markInput = marks.map(item => item.value);
    this.showMarkEdit = false;
  }

  // 保费
  private internationalTradeTerms() {
    console.log("进来了");
    const charge = {
      id: this.declarationInfo.declarationCharge.id,
      bookingOrderId: this.declarationInfo.declarationCharge.bookingOrderId,
      freightAmount: "0.00",
      extrasAmount: "0.00",
      insuranceAmount: "0.00",
    };
    if (this.declarationInfo.customer.internationalTradeTerms === "2") {
      let amount = Number(this.declarationInfo.invoiceMoney);
      amount = amount * 1.1 * 0.001;
      charge.insuranceAmount = amount.toFixed(4);
    }
    this.declarationInfo.declarationCharge = charge;
  }

  private async handleConfirmDeclarationInfo(confirm: boolean) {
    const paymentType = this.declarationInfo.customer.payment;
    if ((paymentType === "CIF" || paymentType === "C&F") &&
        !this.declarationInfo.declarationCharge.freightAmount) {
      return Message.error({ message: "请填写运费" });
    }
    await updateDeclarationInfo(this.bookingOrder.id, {
      confirm,
      ...this.declarationInfo.customer,
      ...this.declarationInfo.declarationCharge,
      shippingMark: this.markInput.join('；'),
      currencyUnit: this.declarationInfo.currencyUnit,
    });
    this.$emit("success");
  }

  private showShippingOrderEdit = false;
  private editShippingOrder() {
    this.showShippingOrderEdit = true;
  }
}

class DeclarationInfo {
  invoiceMoney: string;
  customer: ICustomerModel;
  declarationCharge: DeclarationCharge;
  shippingMark: string;
  currencyUnit: string;

  constructor(
      customer: ICustomerModel,
      declarationCharge: DeclarationCharge,
      invoiceMoney: string,
      shippingMark: string,
      currencyUnit: string
  ) {
    this.customer = customer;
    this.declarationCharge = declarationCharge;
    this.invoiceMoney = invoiceMoney;
    this.shippingMark = shippingMark;
    this.currencyUnit = currencyUnit;
  }
}
class DeclarationCharge {
  id: string;
  bookingOrderId: string;
  freightAmount: string;
  insuranceAmount: string;
  extrasAmount: string;
}
